export default function () {
  return {
    loadingCount: 0,

    isCartLoading: false,
  };
}
